<template>
  <div>
    <Header></Header>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" v-for="item in items" :key="item.id">
          <div class="card mb-1 mt-1">
            <div class="card-body">
              <b class="text-uppercase">{{item.name}}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <infinite-loading
      @infinite="infiniteItems"
      :identifier="infiniteId"
    ></infinite-loading>
  </div>
</template>

<script>
import CollectionMixin from '../../services/collection_mixin'

export default {
  mixins: [CollectionMixin],
  data: function () {
    return {
      resourceName: 'order_kind'
    }
  }
}
</script>

<style scoped>
</style>
